import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { ProductButtonOption } from '../Product/ProductButtonOption';
import { debounce } from 'lodash';

@Component
export class ProductCardQuickAdd extends ThemeComponent {
    @Ref({required: false}) quickAddOptionsContainer!: HTMLElement;
    @Ref({required: false}) quickAddOptions!: HTMLElement;
    @Ref({required: false}) quickAddInner!: HTMLElement;
    @Ref({required: false}) quickAddScrollUp!: HTMLElement;
    @Ref({required: false}) quickAddScrollDown!: HTMLElement;
    @Ref({required: false}) color!: HTMLElement[];

    /* Initialise component */
    init() {}
}
